import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import http from "../../../utils/http";

interface Payload {
  appointmentId: string;
}

export const usePostMeeting = () => {
  const { mutate, ...rest } = useMutation({
    mutationKey: ['post meeting information'],
    mutationFn: async ({ ...data }: Payload) => {
      const response = await http.post("livekit/join", data)
      console.log("response with token",response)
      return response.data;
    },
    onSuccess: () => { },
    onError: (error) => {
      toast.error(axios.isAxiosError(error) ? error?.response?.data?.error : error?.message, {
        type: "error",
        isLoading: false,
        autoClose: 5000,
        closeButton: true,
        toastId: 'error',
      });
    }
  });

  return { postMeeting: mutate, ...rest };
}